import "core-js/modules/es6.function.name";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueCropper } from 'vue-cropper';
export default {
  name: 'CropperDialog',
  components: {
    VueCropper: VueCropper
  },
  data: function data() {
    return {
      data: null,
      option: {
        img: '',
        // 裁剪图片的地址
        info: true,
        // 裁剪框的大小信息
        outputSize: 0.7,
        // 裁剪生成图片的质量
        outputType: 'png',
        // 裁剪生成图片的格式
        canScale: true,
        // 图片是否允许滚轮缩放
        canMoveBox: false,
        canMove: true,
        // 截图框能否拖动图片
        autoCrop: true,
        // 是否默认生成截图框
        autoCropWidth: 300,
        // 默认生成截图框宽度
        autoCropHeight: 300,
        // 默认生成截图框高度
        fixed: true,
        // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1] // 截图框的宽高比例(1:1 正方形)
      },
      dialogVisible: false,
      uploading: false
    };
  },
  methods: {
    handleShow: function handleShow(data) {
      this.data = _objectSpread({}, data);
      this.option.img = data.url;
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.data = null;
      this.option.img = '';
      this.dialogVisible = false;
    },
    // base64 转 blob
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); // 去掉 url 的头，并转换为 byte
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    },
    // 确定裁剪
    ensureCropper: function ensureCropper() {
      var _this = this;
      if (this.uploading) return;
      this.uploading = true;
      this.$refs.cropper.getCropData(function (data) {
        var blob = _this.convertBase64UrlToBlob(data);
        var payload = _objectSpread(_objectSpread({}, _this.data), {}, {
          url: blob,
          name: _this.data && _this.data.name || 'avatar.png'
        });
        _this.$emit('handleSave', payload);
        _this.uploading = false;
      });
    },
    // 取消裁剪
    cancelCropper: function cancelCropper() {
      this.$refs.cropper.clearCrop();
      this.handleClose();
    }
  }
};